import { lazy } from 'react'

export const IntroGoogleVariant1 = lazy(() => import('./IntroGoogleVariant1'))
export const IntroGoogleVariant2 = lazy(() => import('./IntroGoogleVariant2'))
export const IntroGoogleVariant3 = lazy(() => import('./IntroGoogleVariant3'))
export const IntroGoogleVariant4 = lazy(() => import('./IntroGoogleVariant4'))
export const IntroGoogleVariant5 = lazy(() => import('./IntroGoogleVariant5'))
